import BarBox from './BarBox'
import { rem } from 'polished'
import styled from 'styled-components'
import media from '../../../utils/style'

const ShowResultsButton = styled(BarBox)`
  background: ${(props) => props.theme.colors.blue};
  color: ${(props) => props.theme.colors.blue_light};
  text-align: center;
  font-size: ${(props) => rem(props.theme.fontSizes[2])};
  a {
    display: block;
    position: relative;
    cursor: pointer;
    color: white;
    text-decoration: none;
    svg {
      display: inline-block;
      vertical-align: top;
    }
    path {
      transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
    }

    &:hover {
      color: ${(props) => props.theme.colors.blue_light_op70};
      path {
        fill: ${(props) => props.theme.colors.blue_light_op70};
      }
    }
  }

  ${media.LargeScreenUp`
    background-color: ${(props) => props.theme.colors.blue_light};
    color: ${(props) => props.theme.colors.blue};
    mix-blend-mode: multiply;
    height: 60px;
    a, path {
      color: ${(props) => props.theme.colors.blue};
      fill: ${(props) => props.theme.colors.blue};
    }

    &:hover a, &:hover path {
      color: ${(props) => props.theme.colors.blue_op65};
      fill: ${(props) => props.theme.colors.blue_op65} !important;
    }
  `}
`

ShowResultsButton.displayName = 'ShowResultsButton'

export default ShowResultsButton
